import {combineReducers, applyMiddleware, compose, createStore} from 'redux';

import {thunk} from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import {all as allSagas} from 'redux-saga/effects';

import {reducer as formReducer} from 'redux-form';
import {reducer as courseReducer} from './reducers/course.reducer';
import {reducer as configReducer} from './reducers/config.reducer';

import {sagas as courseSagas} from './sagas/course.sagas';
import {sagas as configSagas} from './sagas/config.sagas';

function* rootSaga() {
  console.log('root.');
  yield allSagas([...courseSagas, ...configSagas]);
}

export const configureStore = initialState => {
  const reducers = combineReducers({
    course: courseReducer,
    form: formReducer,
    config: configReducer,
  });

  const sagaMiddleware = createSagaMiddleware({
    onError: error => {
      console.error(error);
      // eslint-disable-next-line no-use-before-define
      store.dispatch({
        type: 'ERROR',
        payload: error,
      });
    },
  });
  const middlewares = [thunk, sagaMiddleware];

  const enhancer
    = process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__
      ? compose(
        applyMiddleware(...middlewares),
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({serialize: true, trace: true}),
      )
      : compose(applyMiddleware(...middlewares));

  const store = createStore(reducers, initialState, enhancer);

  sagaMiddleware.run(rootSaga);

  return store;
};
